
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { initPageViewTimer, reportPageView } from '@/utils/pageViewReporter';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AnnouncementBar from '@/components/AnnouncementBar';
import WhatsAppWidget from '@/components/WhatsAppWidget';
import { CartDrawer } from '@/components/CartDrawer';

export const PublicLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const hash = window.location.hash;

    // If recovery context is present on any public page, redirect to dedicated reset page
    if (location.pathname !== '/reset-password') {
      if (code) {
        navigate(`/reset-password?code=${encodeURIComponent(code)}` as const, { replace: true });
        return;
      }
      if (hash.includes('type=recovery') && hash.includes('access_token')) {
        navigate(`/reset-password${hash}` as const, { replace: true });
        return;
      }
    }
  }, [location, navigate]);

  // Track page views — measure actual render time
  useEffect(() => {
    initPageViewTimer();
    // Small delay lets the browser finish rendering, then report.
    // More reliable than requestIdleCallback across all mobile browsers/WebViews.
    const timer = setTimeout(() => {
      reportPageView(location.pathname);
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="fixed top-0 left-0 right-0 z-50 bg-background">
        <AnnouncementBar />
        <Header />
      </div>
      <main className="flex-grow pt-[125px]">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppWidget />
      <CartDrawer />
    </div>
  );
};
